import React from 'react';
import './App.css';
import Wordsmyth from './containers/Wordsmyth';

function App() {
  return (
    <div className="App">
      <Wordsmyth/>
    </div>
  );
}

export default App;
